/**
 * Web Push VAPID public key (safe to ship in the client bundle).
 * Override at build time with REACT_APP_VAPID_PUBLIC_KEY if needed.
 * Must match functions VAPID_PUBLIC_KEY / VAPID_PRIVATE_KEY pair.
 */
const DEFAULT_VAPID_PUBLIC_KEY =
  'BCZbwJSyZzzhwtGg8bxf0VGyVp1CCnxgPVbwLLwTODs1OzTb_GQufgsfGmzLppbJ4OyKOts56pDdRwRBqciQIuI';

export const getVapidPublicKey = () =>
  process.env.REACT_APP_VAPID_PUBLIC_KEY || DEFAULT_VAPID_PUBLIC_KEY;

export default getVapidPublicKey;
